import React, { useEffect, useState } from "react"
import Sidebar from "../components/sidebar"
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";

import Topbar from "../components/topbar";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Pagination from "../components/Pagination";
import SidebarUserAgency from "../components/SidebarUserAgency";
import TopbarAgencyUser from "../components/TopBarAgencyUser";
import { errorMessage } from "../hooks/UserLogs";
import ConfirmModal from "../components/confirmModal";
export default function MasterDepositByAgency() {
  const [view, setView] = useState(false);
  const [totalPage, setTotalPage] = useState(1)
  const [currentPage, setCurrentPage] = useState(1)
  const [ListInvoices, setListInvoices] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [code, setCode] = useState("");
  const [firstNamelUp, setFirstNameUp] = useState("");
  const [lastNamelUp, setLastNameUp] = useState("");
  const [middleNamelUp, setMiddleNameUp] = useState("");
  const [phoneUp, setPhoneUp] = useState("");
  const [emailUp, setEmailup] = useState("");
  const [genderUp, setGenderUp] = useState("");
  const [errorForm, setErrorForm] = useState({});
  const [errMsg, setErrorMsg] = useState("Une erreure s'est produite!!");
  const [showError, setShowError] = useState(false);
  const [idUp, setIdUp] = useState(0);
  const [trxType, setTrxType] = useState(0);
  const [imgUrl, setImgUrl] = useState('');
  const [accountingAgent, setAccountingAgent] = useState(0);
  const [openAppro, setOpenAppro] = useState(false);
  const [amountAppro, setAmountAppro] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState('');
  const [transactionStatus, setTransactionStatus] = useState('');

  const [showModalConfirmValidation, setShowModalConfirmValidation] = useState(false);
  const [idInvoiceAgencyMaster, setIdInvoiceAgencyMaster] = useState('');

  const convertToDate = (resultDate) => {
    const yyyy = resultDate.getFullYear();
    let mm = resultDate.getMonth(); // Months start at 0!
    let dd = resultDate.getDate();
    mm = mm + 1;
    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;
    return yyyy + '-' + mm + '-' + dd + 'T00:00:00.000Z';
  }

  let defaultBgDate = new Date()
  defaultBgDate.setDate(defaultBgDate.getDate() - 7)
  let defaultEndDate = new Date();
  defaultEndDate.setDate(defaultEndDate.getDate() + 1)
  const [beginDate, setBeginDate] = useState(defaultBgDate);
  const [endDate, setEnDate] = useState(defaultEndDate);


  const handleShowConfirmValidation = (id) => {
    setShowModalConfirmValidation(true);
    setIdInvoiceAgencyMaster(id);

  }

  const handleCloseConfirmValidation = () => setShowModalConfirmValidation(false);

  const axiosInstance = axios.create({
    withCredentials: true,
  })

  let header =
  {
    'Content-Type': 'application/json'
  };

  const handleClose = () => {
    setErrorForm({});
    setFirstNameUp("")
    setLastNameUp("")
    setMiddleNameUp("")
    setGenderUp("");
    setEmailup("")
    setIdUp(0);
    setPhoneUp("")
    setView(false)

  }
  const approRquest = async () => {
    axiosInstance.post(bUrl + "/invoice-startup-master/initiate-invoice-startup-master-by-agency",

      {
        "fkIdAgencyUser": sessionStorage.getItem('idAgencyUser'),
        "amountToSend": amountAppro
      }

      , { header: header })
      .then(function (response) {
        getListInvoices(email, phone, code)
        getAgency()
        setIsLoading(false)

        if (response?.data?.isError) {
          const msg = errorMessage(response?.data?.code)
          setErrorMsg(msg);
          setShowError(true);
        }

        setOpenAppro(false);

      })
      .catch(function (err) {

        setIsLoading(false);
        setOpenAppro(false);
        if (err?.response?.status == 401 || err?.response?.status == 403) {
          setErrorMsg("Vous n'étes pas autorisé à faire cette opération")
          setShowError(true);
        } else {
          setShowError(true);
        }
        //setShowError(true);
      });
  }
  const viewOpenAppro = () => {
    setOpenAppro(true);
  }

  const viewCloseAppro = () => {
    setOpenAppro(false);
  }

  const viewClose = () => {
    setView(false)
  }

  const getAgency = async () => {
    let idAgency = sessionStorage.getItem('idAgency');
    const response = await axiosInstance.get(bUrl + "/agencies/agency-by-id?id=" + idAgency).catch((err) => {
      ;
      setIsLoading(false)
    });
    if (response) {

      if (!response.data.isError) {
        if (response.data.body.accounting != null) {
          setAccountingAgent(response.data.body.accounting.balance)
        }

      } else {
        const msg = errorMessage(response?.data?.code)
        setErrorMsg(msg);
        setShowError(true);
      }

      if (response?.status == 401) {
        navigate('/agency-user-login');
      }

    }
  }
  const getImgUrl = async (key) => {

    const response = await axiosInstance.get(bUrl + "/getFileUploaded?key=" + key).catch((err) => {
      setIsLoading(false)
    });
    if (response) {

      if (!response.data.isError) {
        setImgUrl(response.data.body)
      } else {
        const msg = errorMessage(response?.data?.code)
        setErrorMsg(msg);
        setShowError(true);
      }
      if (response.status == 401) {
        navigate('/agency-user-login');
      }


    }
  }
  const viewOpen = (key) => {
    getImgUrl(key)
    setView(true)
  }
  const handleCloseError = () => {
    setShowError(false);
  }

  const updateForm = () => { }

  const bUrl = process.env.REACT_APP_B_URL;

  const { id } = useParams();
  const navigate = useNavigate();
  const getListInvoices = async (beginDateInput, endDateInput, transactionStatus, paymentMethod, code) => {

    let idAgency = sessionStorage.getItem('idAgency');
    let ulr = "/invoice-startup-master/by-agency?idAgency=" + idAgency + "&page=" + currentPage + "&limit=10";
    setCode(code);
    setEnDate(new Date(endDateInput));
    setPaymentMethod(paymentMethod);
    setBeginDate(new Date(beginDateInput));
    setTransactionStatus(transactionStatus);

    if (code != '' || paymentMethod != '' | transactionStatus != '' || beginDateInput != '') {
      ulr = "/invoice-startup-master/by-agency/search?page=" + currentPage + "&limit=10&agenceCode=" + sessionStorage.getItem('codeAgency');
      if (transactionStatus != '') {
        ulr += "&status=" + transactionStatus;
      }
      if (code != '') {
        ulr += "&code=" + code;
      }
      if (paymentMethod != '') {
        ulr += "&paymentMethod=" + paymentMethod;
      }

      if (beginDateInput != '') {
        ulr += "&beginDate=" + convertToDate(new Date(beginDateInput));
      }

      if (endDateInput != '') {
        ulr += "&endDate=" + convertToDate(new Date(new Date(endDateInput)));
      }
      //console.log(ulr)
    }
    const response = await axiosInstance.get(bUrl + ulr).catch((err) => {

      if (err?.response?.status == 401 || err?.response?.status == 403) {
        setErrorMsg("Vous n'étes pas autorisé à faire cette opération")
        setShowError(true);
      } else {
        setShowError(true);
      }

      console.error(err);
      setIsLoading(false)

    });

    if (response) {
      if (response?.data?.isError) {
        const msg = errorMessage(response?.data?.code)
        setErrorMsg(msg);
        setShowError(true);
      } else {
       
        setListInvoices(response.data.body);
        setTotalPage(response.data.totalPage);
        setCurrentPage(response.data.currentPage);
        setIsLoading(false);
      }

      if (response?.status == 401) {
        navigate('/backoffice/login');
      }

    }
  }



  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric", hour: 'numeric', minute: 'numeric', second: 'numeric' }
    return new Date(dateString).toLocaleDateString(undefined, options)
  }
  const validateAgencyMasterTransactions = () => {

    setIsLoading(true);

    axiosInstance.post(bUrl + "/invoice-startup-master/validate-transactions-by-agency-user",

      //birthDay: birthDay,
      {
        "fkIdStaff": "01JBPYN9YFESX5DG88M5NWD8R3",
        "idAgencyUser": sessionStorage.getItem('idAgencyUser'),
        "idInvoiceStartupMaster": idInvoiceAgencyMaster
      }

      , { header: header })
      .then(function (response) {
        getListInvoices(beginDate, endDate, email, phone, code)
        setIsLoading(false)
        
        if (response?.data?.isError) {
          const msg = errorMessage(response?.data?.code)
          setErrorMsg(msg);
          setShowError(true);
        }

      })
      .catch(function (err) {
        setIsLoading(false)

        if (err?.response?.status == 401 || err?.response?.status == 403) {
          setErrorMsg("Vous n'étes pas autorisé à faire cette opération")
          setShowError(true);
        } else {
          setShowError(true);
        }
        //setShowError(true);
      });

    handleCloseConfirmValidation()

  }
  useEffect(() => {
    if (sessionStorage.getItem("idAgency") === '' || sessionStorage.getItem("idAgency") === null) {
      //console.log("----------GO GO GO ------------")
      navigate('/agency-user-login');
    }
    getAgency();
    getListInvoices(beginDate, endDate, email, phone, code);
    
  }, [currentPage])

  return (
    <div className="App">
      <div className="">
        <SidebarUserAgency />
        <section className="home ">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-12">
              <div className="table-content mt-2 p-2 text d-flex justify-content-between">
                <div className="d-flex justify-content-between">


                  <div className="ml-2">
                    {isVisible ? <p className='fw-bold ' style={{ "font-size": 20 }}>{accountingAgent.toFixed(3)} GNF</p> :
                      <p className='fw-bold ' style={{ "font-size": 25 }}>-----------</p>}
                  </div>


                  {!isVisible ? <div className="mx-2 clickable" onClick={() => setIsVisible(true)} style={{ "font-size": 30, "z-index": 5000 }}><i className='bx bx-show'  ></i>
                  </div> : <div className="mx-2 clickable" onClick={() => setIsVisible(false)} style={{ "font-size": 30, "z-index": 5000 }}>
                    <i className='bx bx-low-vision '  ></i>
                  </div>
                  }





                </div>

                <div><TopbarAgencyUser /></div>
              </div>

              <div className="table-content mt-3 p-3">
                <div className="d-flex justify-content-around">
                  <div className="form-group text">
                    <label htmlFor="exampleInputEmail1">Début</label>
                    <input type="Date" value={beginDate.toLocaleDateString('en-CA')} onChange={(e) => getListInvoices(e.target.value, endDate, transactionStatus, paymentMethod, code)} className="form-control" id="exampleInputEmail1" />
                  </div>

                  <div className="form-group text">
                    <label htmlFor="phone">Fin</label>
                    <input type="Date" value={endDate.toLocaleDateString('en-CA')} onChange={(e) => getListInvoices(beginDate, e.target.value, transactionStatus, paymentMethod, code)} className="form-control" id="phone" aria-describedby="Phone" placeholder="Phone" />
                  </div>

                  <div className="form-group text">
                    <label htmlFor="exampleInputEmail1">Statut</label>
                    <select onChange={(e) => getListInvoices(beginDate, endDate, e.target.value, paymentMethod, code)} className="form-control" value={transactionStatus}>
                      <option value="">Selectionner</option>
                      <option value="A">En Attente</option>
                      <option value="P">Payée</option>
                    </select>
                  </div>

                  <div className="form-group text">
                    <label htmlFor="exampleInputEmail1">Type</label>
                    <select onChange={(e) => getListInvoices(beginDate, endDate, transactionStatus, e.target.value, code)} className="form-control" value={paymentMethod}>
                      <option value="">Selectionner</option>
                      <option value="AM">Depot</option>
                      <option value="SM">Approvisionnement</option>
                    </select>
                  </div>
                  <div className="form-group text">
                    <label htmlFor="code">Code</label>
                    <input type="text" onChange={(e) => getListInvoices(beginDate, endDate, transactionStatus, paymentMethod, e.target.value)} className="form-control" id="code" aria-describedby="Phone" placeholder="Code" />
                  </div>
                </div>
              </div>
              <div className="table-content mt-3 p-3">
                <button onClick={() => viewOpenAppro()}>
                  <i className='bx bxs-plus-circle icon' ></i>
                </button>
                {/* <a href="/Home/Create" className="btn btn-primary mb-1"> </a> */}
                <div className="table-responsive-xl">
                  {isLoading ? <div className='loading'><img src='../Custom.svg' /></div> :

                    <table className="table text">
                      <thead>
                        <tr>

                          <th scope="col">N</th>
                          <th scope="col">Code</th>
                          <th scope="col">Agent</th>
                          <th scope="col">Utilisateur</th>
                          <th scope="col">Status</th>
                          <th scope="col">Montant</th>
                          <th scope="col">Date</th>
                          <th></th>
                          <th></th>
                          <th></th>
                        </tr>
                      </thead>

                      <tbody>
                        {ListInvoices != null ? ListInvoices.length > 0 ? ListInvoices.map((a, i) => {
                          return <tr>
                            <td>{i}</td>
                            <td>{a.invoiceCode}</td>
                            <td>{a.agent ? a.agent.phone : ""}</td>
                            <td>{a.agencyUser ? a.agencyUser.login : ""}</td>
                            <td style={{ background: a.invoiceStatus == 'P' ? "rgb(0,255,0,.3)" : a.invoiceStatus == 'A' ? "rgb(0,200,255,.3)" : "rgb(255,0,0,.3)" }}>{a.invoiceStatus == 'P' ? 'Payée' : a.invoiceStatus == 'A' ? 'En Attente' : 'Annulée'}</td>
                            <td>{a.amountToPaid.toFixed(3)}</td>
                            <td>{formatDate(a.createdDate)}</td>
                            {
                              a.agent != null ? a.invoiceStatus == 'A' ?
                                <td><Link onClick={() => handleShowConfirmValidation(a.idInvoiceStartupMaster)}><i className='bx bx-caret-up-square' title="Validé"></i></Link></td>
                                : <> </> : <></>
                            }

                            <td><Link onClick={() => viewOpen(a.proofLink)}><i className='bx bx-shield-alt-2' title=""></i></Link></td>
                            <td><Link to={"/invoiceStartupMasterOfAgency/" + a.idInvoiceStartupMaster}> <i className='bx bx-notepad' title="Détails"></i></Link></td>




                          </tr>
                        }) : <tr></tr> : ""}
                      </tbody>

                    </table>
                  }
                </div>
                <Pagination totalPage={totalPage} setCurrentPage={setCurrentPage} currentPage={currentPage} />
              </div>

            </div>
          </div>
        </section>
      </div>
      <Modal show={view} onHide={handleClose} className="">
        <Modal.Header closeButton>
          <Modal.Title className="text-center"></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {(imgUrl != '') ? <img src={imgUrl} className="w-100" alt="image" /> : <p>Pas de preuve disponible</p>}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Fermer
          </Button>

        </Modal.Footer>
      </Modal>
      {/* ========================================================================== */}
      <Modal show={openAppro} onHide={viewCloseAppro} className="">
        <Modal.Header closeButton>
          <Modal.Title className="text-center">Demande approvisionnement</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="w-100 d-flex justify-content-center">
            <div className="row">
              <div className="d-flex col-md-12">
                <div className="w-25">
                  <label htmlFor="phone" className="col-sm-2 col-form-label d-block" >Montant:&nbsp;&nbsp;</label>
                </div>
                <div className="w-100">
                  <input id="phone" type="number" value={amountAppro} className="mr-2 col-sm-8 form-control w-50 " onChange={(e) => setAmountAppro(e.target.value)} />
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={approRquest}>
            Demander
          </Button>

        </Modal.Footer>
      </Modal>

      {/* =============================================error=============================== */}
      <Modal show={showError} onHide={handleCloseError} className="">
        <Modal.Header closeButton className="bg-danger">
          <Modal.Title>ERREURE</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h5 className='text-danger' style={{ textAlign: 'center' }}>{errMsg}</h5>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseError}>
            Fermer
          </Button>
        </Modal.Footer>
      </Modal>

      <ConfirmModal
        show={showModalConfirmValidation}
        handleClose={handleCloseConfirmValidation}
        handleConfirm={validateAgencyMasterTransactions}
      />
    </div>
  )
}